import React from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import styles from './Billing.scss'
import {QuickStats} from '../QuickStats'
import {experienceSelectors} from 'data/resources/experiences'
import {appCodeUseActions, appCodeUseSelectors} from 'data/resources/appCodeUses'
import {Loadable} from 'common/Loadable'
import {SectionBox} from 'common/styleguide/SectionBox'
import {CTA} from 'common/styleguide/CTA'
import {Icon} from 'common/Icon'
import fetchJSON from 'lib/fetchJSON'
import moment from 'moment'
import Helmet from 'react-helmet'

export class _Billing extends React.PureComponent {
  render () {
    const {experience, appCodeUseIds, findAppCodeUse, loadableResources} = this.props

    return (
      <div className={styles.Billing}>
        {experience && <Helmet title={experience.name} />}
        <div className={styles.header}>
          <QuickStats totals={loadableResources.stats.stats} className={styles.quickStats} />
          <CTA
            secondary
            margins={false}
            href={`/app_code_uses.csv?parent_type=Experience&parent_id=${experience.id}`}
            className={styles.aSpecificity}>
            <Icon i='md-download' size={20} />Export CSV
          </CTA>
        </div>
        <SectionBox className={styles.statsCard}>
          {experience && <React.Fragment>
            <div className={styles.cardHeader}>
              <span>
                <Link to={`/organizations/${experience.clubId}/experiences_billing`}>Back</Link>
                {<h2><Link to={`/experiences/${experience.id}/edit`}>{experience.name}</Link></h2>}
              </span>
            </div>
            {appCodeUseIds && (
              <table className={styles.guestsTable}>
                <thead>
                  <tr>
                    <th>Date Accessed</th>
                    <th>First name</th>
                    <th>Last name</th>
                    <th>Email address</th>
                    <th>Phone number</th>
                    <th>Reference ID</th>
                  </tr>
                </thead>
                <tbody>
                  {appCodeUseIds.map(acuId => {
                    const appCodeUse = findAppCodeUse(acuId)
                    if (!appCodeUse) {
                      return null
                    } else {
                      return (
                        <tr key={appCodeUse.id}>
                          <td>{moment(appCodeUse.createdAt).format('MMM D, YYYY [at] h:mma')}</td>
                          <td>{detail(appCodeUse, 'first_name')}</td>
                          <td>{detail(appCodeUse, 'last_name')}</td>
                          <td>{detail(appCodeUse, 'email')}</td>
                          <td>{detail(appCodeUse, 'phone')}</td>
                          <td>{detail(appCodeUse, 'reference_id')}</td>
                        </tr>
                      )
                    }
                  })}
                </tbody>
              </table>
            )}
          </React.Fragment>}
        </SectionBox>
      </div>
    )
  }
}

const detail = (appCodeUse, key) => {
  if (appCodeUse.requestedDetails && appCodeUse.requestedDetails.hasOwnProperty(key)) {
    return appCodeUse.requestedDetails[key]
  } else {
    return '- -'
  }
}

const loadInitialData = (props) => {
  const experienceId = parseInt(props.params.experienceId, 10)
  const loadStats = fetchJSON(`/experiences/${experienceId}/stats.json`)
  const loadACUs = props.loadACUs('Experience', experienceId)

  return Promise.all([
    loadStats,
    loadACUs
  ]).then(([stats, _]) => ({stats}))
}

export const LoadableBilling = (props) => {
  return <Loadable
    {...props}
    component={_Billing}
    loadingText='Loading Guests'
    resourceLoaded={() => loadInitialData(props)} />
}

const mapStateToProps = (state, ownProps) => {
  const experienceId = parseInt(ownProps.params.experienceId, 10)

  return {
    experience: experienceSelectors.find(state, experienceId),
    appCodeUseIds: appCodeUseSelectors.byParent(state, 'Experience', experienceId),
    findAppCodeUse: (acuId) => appCodeUseSelectors.find(state, acuId)
  }
}

const mapDispatchToProps = {
  loadACUs: appCodeUseActions.loadAllAppCodeUses
}

export const Billing = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableBilling)
